import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import HideSourceIcon from '@mui/icons-material/HideSource';
import { blue, blueGrey } from '@mui/material/colors';
import { useDrag } from 'react-dnd'
import { useDrop } from 'react-dnd'
import update from 'immutability-helper'

import { ButtonGroup, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Stack, TextField, Typography } from '@mui/material';
import ColumnFormDialog from './ColumnFormDialog';
import Service from '../../../util/Service';
import KanbanCard from './KanbanCard2';
import { AddCircleOutlineOutlined, RemoveCircle, Save } from '@mui/icons-material';
import KanbanCardMoverTodosMenu from './KanbanCardMoverTodosMenu';
import { useProfile } from '../../common/useProfile';
import { TYPES } from '../../../util/ServiceWS';

export default function ColumnCard(props) {
    const { projeto, papeis, temAcessoBasico, col, atualizaCol, kanban, action, lista, setLista, openMsg } = props;
    const [openComunFormDialog, setOpenComunFormDialog] = React.useState(false);
    const [showNovoCartao, setShowNovoCartao] = React.useState(false);
    const color = blueGrey[50];
    const ref = React.useRef(null);
    const refDND = React.useRef(null);
    const refDrop = React.useRef(null);
    const [showBtnSalvar, setShowBtnSalvar] = React.useState(false);
    const [nome, setNome] = React.useState('');
    const [novaColuna, setNovaColuna] = React.useState();
    const prof = useProfile();
    const [listView, setListView] = React.useState([]);
    
    React.useEffect(() => {
        if (lista && lista.length > 0) {
            let arr = [...lista].filter(l => l.idColuna === col.id).sort((a, b) => a.ordem - b.ordem);
            for (let x = 0; x < arr.length; x++) {
                arr[x].ordem = x + 1;
            }
            setListView(arr);
        }
    }, [lista]);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        if (ref.current) {
            setTimeout(() => {
                ref.current.focus();
            }, 300);
        }
    };
    function handleEdit(e) {
        handleClose();
        setOpenComunFormDialog(true);
    }
    function handleNovoCartao() {
        handleClose();
        setShowNovoCartao(true);
    }

    const [{ handlerId }, drop] = useDrop({
        accept: 'card',
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item, monitor) {
            if (!ref.current) {
                return
            }
            // setListView([...listView, t]);
            const arr = [...lista];
            const t = arr.find(i => i.id === item.id);
            // console.log(t, col.id);
            setNovaColuna({
                id: t.id,
                idColuna: col.id
            })
            t.idColuna = col.id;
            t.ordem = 0;
            setLista((prevCards) =>
                update(prevCards, {
                    $set: arr,
                }),
            )
            // action({
            //     type: TYPES.cardMoveOutraColuna,
            //     dado: t
            // });
        },
        drop: (item, monitor) => {
            console.log('fim====>', novaColuna)
            action({
                type: TYPES.cardMoveOutraColuna,
                dado: novaColuna
            });
        }
    })

    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'coluna',
        item: col,
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult();
            if (item && dropResult) {
                if (atualizaCol) atualizaCol(item, dropResult);
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            handlerId: monitor.getHandlerId(),
        }),
    }))
    const opacity = isDragging ? 0.4 : 1

    function handleSalvaNomeColuna(c) {
        console.log(c.nome, col, kanban);
        const dado = {
            idKanban: kanban.id,
            id: col.id,
            nome: c.nome,
            regra: c.regra
        }
        console.log( dado );
        
        Service.POST("/api/projeto/kanbanColumn", dado).then(r => {
            console.log(r, TYPES);
            if (r.success) {
                // action( r.kanban);
                action({
                    type: TYPES.cUpdate,
                    dado: r.kanban
                });
            }
        })
    }
    function handleFocusLost(e) {
        console.log(">>>handleFocusLost<<<", e.target.value);
        setShowNovoCartao(false);
        if (!e.target.value || e.target.value.lenght < 2) return;
        const card = {
            idKanban: kanban.id,
            idColuna: col.id,
            nome: e.target.value,
        }
        setNome('');
        criarCartao(card);

    }
    function handleOnChange(e) {
        if (e.key === 'Enter') {
            const card = {
                idKanban: kanban.id,
                idColuna: col.id,
                nome: e.target.value,
            }
            criarCartao(card);
            setNome('');
        }
    }

    function criarCartao(card) {
        Service.POST("/api/security/projeto/kanban/card", card).then(r => {
            console.log(r);
            let arr = [r.card, ...lista];
            setLista(arr);

            action({
                type: TYPES.cardNovo,
                dado: r.card
            }
            );
        })
    }
    
    function moveCard(dragIndex, hoverIndex, idSource, idTarget) {
        console.log(dragIndex + '....' + hoverIndex);
        if( !temAcessoBasico ){
            openMsg({
                severity:'warning',
                txt:'Sem permissão!',
            })
            return;
        }
        
        setListView((prevCards) => (
            update(prevCards, {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, prevCards[dragIndex]],
                ],
            })
        )
        );
    }
    function handleColumnChange() {
        console.log(listView)
        setShowBtnSalvar(false);

        let arr = [];
        // for(let x in listView){
        for (let x = 0; x < listView.length; x++) {
            arr.push({
                id: listView[x].id,
                ordem: x + 1 //listView[x].ordem
            })
        }
        action({
            type: TYPES.cardMove,
            dado: arr
        });
    }
    function handleOcultar(){
        console.log( col, kanban)
        const dado ={
            idKanban: kanban.id,
            idCol: col.id
        }
        Service.POST("/api/security/projeto/kanbanColumn/hide", dado).then(r => {
            console.log( r );
            window.location.reload(true);
        })
    }
    function handleArquivarTodos(){
        console.log( listView );
        const arr = [];
        for(let item of listView){
            arr.push( item.id)
        }
        Service.POST("/api/security/projeto/kanban/cardsArquivar", arr).then(r => {
            console.log( r );
            action({
                type: TYPES.cardArquivar,
                dado: arr
            });
            handleClose();
        })
    }
    function handleMoverTodos(row){
        console.log( row );
        const arr = [];
        for(let item of listView){
            arr.push( item.id)
        }
        const dado = {
            ids: arr,
            idColuna: row.id,
        }
        console.log( dado );
        
        Service.POST('/api/security/projeto/kanban/moverCardsColuna', dado).then(r => {
            action({
                type: TYPES.cardsMoveOutraColuna,
                dado: arr
            });
            handleClose();
        })
    }
    
    drag(refDND);
    drop(refDrop);

    return (

        <Card sx={{
            minWidth: 280,
            maxWidth: 280,
            opacity,
            background: color,
            m: 0,
            mt: 0,
        }}
            ref={refDND}
        >
            <CardHeader size='small' sx={{ background: blueGrey[100], height: '24px' }}
                action={
                    <ButtonGroup sx={{ mt: -3 }} variant="text">
                        {showBtnSalvar && temAcessoBasico && <IconButton
                            sx={{ color: blue[500] }}
                            onClick={handleColumnChange}
                        >
                            <Save />
                        </IconButton>}
                        <IconButton onClick={handleClick} size='small' disabled={!temAcessoBasico}>
                            <MoreVertIcon />
                        </IconButton>
                    </ButtonGroup>
                }
                // title="Shrimp and Chorizo Paella"
                subheader={<b>{col.nome}</b>}
                ref={refDrop}
            />

            <CardContent>
                <Stack sx={{ mt: -1 }} spacing={1} >
                    <TextField
                        // autoFocus 
                        inputRef={ref}
                        sx={{ display: showNovoCartao ? 'block' : 'none', mt: 10 }}
                        label="Nome do Cartão" fullWidth size='small'
                        value={nome} onChange={(e) => setNome(e.target.value)}
                        onBlur={handleFocusLost}
                        onKeyDown={handleOnChange}
                    />
                    {/* {showNovoCartao && */}
                    {/* <input type="text" ref={ref} 
                            value={nome} onChange={(e) => setNome(e.target.value)}
                            style={{ display:showNovoCartao?'block':'none'}}
                            onBlur={handleFocusLost}
                            onKeyDown={handleOnChange}
                        /> */}
                    {/* } */}


                    {listView && listView.map((row, index) => {
                        if( !row) return;
                        return(
                            <KanbanCard
                                key={index}
                                index={index}
                                cartao={row}
                                id={row.id}
                                col={col}
                                kanban={kanban}
                                action={action}
                                lista={listView} setLista={setListView}
                                TYPES={TYPES}
                                moveCard={moveCard}
                                setShowBtnSalvar={setShowBtnSalvar}
                                temAcessoBasico={temAcessoBasico}
                                projeto={projeto}
                                papeis={papeis}
                            />
                        )
                    })}
                </Stack>
            </CardContent>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                sx={{ width: 320 }}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                <Typography align='center' variant="h6" gutterBottom>Ações da lista</Typography>
                <MenuItem onClick={handleNovoCartao}>
                    <ListItemIcon>
                        <AddCircleOutlineOutlined fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Novo Cartão</ListItemText>
                </MenuItem>
                {listView && listView.length >0 && 
                <KanbanCardMoverTodosMenu 
                    col={col} 
                    kanban={kanban}
                    arquivarTodos={handleArquivarTodos}
                    moverTodos={handleMoverTodos}
                /> }
                <MenuItem onClick={handleClose}>
                    <ListItemText>Ordernar por</ListItemText>
                </MenuItem>
                {/* <MenuItem onClick={(e) => {
                    console.log(listView);
                    for (let i in listView) {
                        const item = listView[i];
                        console.log(item.nome + "(" + item.ordem + ")");
                    }
                    handleClose();
                    ref.current.focus();
                }}>
                    <ListItemText>Teste</ListItemText>
                </MenuItem> */}
                <Divider />
                <MenuItem onClick={handleEdit}>
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Editar</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <RemoveCircle fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Remover</ListItemText>
                </MenuItem>
                <MenuItem onClick={ handleOcultar}>
                    <ListItemIcon>
                        <HideSourceIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Ocultar</ListItemText>
                </MenuItem>
            </Menu>
            <ColumnFormDialog
                open={openComunFormDialog}
                setOpen={setOpenComunFormDialog}
                column={col}
                action={handleSalvaNomeColuna}
            />
        </Card>
    );
}
